import instance from '@/config/axios'
import type { GetBrandsResponse, PostBrandRequest, PostBrandResponse } from './type'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCollableMutation } from '@/config/useCollableMutation'

export const apiGetBrands = async (keyword: string) => {
  const response = await instance.get<GetBrandsResponse>('/v1/brands', {
    params: {
      keyword,
    },
  })
  return response.data
}

export const useGetBrands = (keyword: string) => {
  return useQuery({
    queryKey: ['brands', keyword],
    queryFn: () => apiGetBrands(keyword),
    enabled: !!keyword,
    select: data => data.brands.filter(brand => brand.status === 'ACTIVATED'),
  })
}

export const apiPostBrand = async (payload: PostBrandRequest) => {
  const response = await instance.post<PostBrandResponse>('/v1/brands', payload)
  return response.data
}

export const usePostBrand = () => {
  const queryClient = useQueryClient()
  return useCollableMutation({
    mutationFn: apiPostBrand,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['brands'], type: 'all' })
    },
  })
}
